export default class SessionError extends Error {

}
